import type { CompiledMongoPagination } from "./compileMongoPagination"


type MongoQueryLike = {
  where: (delta: Record<string, unknown>) => unknown;
  sort: (sort: Record<string, 1 | -1>) => unknown;
  limit: (limit: number) => unknown;
}

export const MongoAdapter = {
  applyPagination: <TQuery extends MongoQueryLike>(query: TQuery, compiled: CompiledMongoPagination): TQuery => {
    query.where(compiled.mongoFilterDelta)
    query.sort(compiled.mongoSort)
    query.limit(compiled.mongoLimit)
    return query
  },
}

